import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=7da317fe&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=7da317fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da317fe",
  null
  
)

export default component.exports